function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var L = Object.defineProperty;
var o = Object.getOwnPropertySymbols;
var r = Object.prototype.hasOwnProperty,
    d = Object.prototype.propertyIsEnumerable;

var t = function t(l, C, e) {
  return C in l ? L(l, C, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : l[C] = e;
},
    n = function n(l, C) {
  for (var e in C || (C = {})) {
    r.call(C, e) && t(l, e, C[e]);
  }

  if (o) {
    var _iterator = _createForOfIteratorHelper(o(C)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var e = _step.value;
        d.call(C, e) && t(l, e, C[e]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return l;
};

import * as i from "react";

function v(l) {
  return i.createElement("svg", n({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, l), i.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9659 8.21002H11.9406C11.4862 8.21002 11.116 7.83954 11.116 7.37644V4.82516C11.116 4.37048 11.4862 4 11.949 4H11.9743C12.4286 4 12.7989 4.37048 12.7989 4.82516V7.38486C12.7989 7.83954 12.4286 8.21002 11.9659 8.21002ZM17.2584 9.98669C16.9302 10.3151 16.4085 10.3151 16.0804 9.98669L16.0719 9.96985C15.7438 9.64989 15.7438 9.11943 16.0719 8.79947L17.8978 6.98916C18.2176 6.6692 18.7477 6.6692 19.0674 6.98916C19.3956 7.30912 19.3956 7.83958 19.0674 8.15954C18.5373 8.69001 17.78 9.45623 17.2584 9.98669ZM6.66487 9.97858C6.98461 10.307 7.51471 10.307 7.84287 9.97858C8.16261 9.65861 8.16261 9.12815 7.84287 8.80819L6.0338 6.98104C5.71405 6.65266 5.18395 6.65266 4.86421 6.98104L4.84738 6.98946C4.51922 7.31784 4.51922 7.83989 4.84738 8.15985C5.37748 8.68189 6.14318 9.44811 6.66487 9.97858ZM2.54179 15.9816C7.93535 11.2159 16.0635 11.2159 21.4571 15.9816C22.1723 16.6131 22.1723 17.733 21.5076 18.4066L20.481 19.4339C19.8752 20.0401 18.916 20.0906 18.2428 19.5602L16.5684 18.2298C16.1645 17.9098 15.9289 17.4215 15.9289 16.9078V14.7102C13.3794 13.8766 10.6279 13.8851 8.0868 14.7102V16.8994C8.0868 17.413 7.8512 17.9014 7.44732 18.2214L5.76446 19.5602C5.09132 20.0906 4.13209 20.0401 3.52626 19.4339L2.49972 18.4066C1.82657 17.733 1.82657 16.6131 2.54179 15.9816Z",
    fill: "black"
  }));
}

export { v as ReactComponent };